import {
    useCallback,
} from 'react'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes/skyNetRoutes.utils'
import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'
import {
    OrderTypes,
} from 'app/enums/label.enums'

const useOrderLink = () => {
    const Routes = useOrderManagementRoutes()

    return useCallback((orderNumber: string, orderType: OrderTypes) => {
        const matchedDomainPath = orderType === OrderTypes.CUSTOMER_TRANSPORT
            ? Routes.CustomerOrders.Overview.path : Routes.InternalOrders.Overview.path

        return generateSkyNetLink({
            domainPath: matchedDomainPath,
            params: {
                key: orderNumber,
            },
        })
    }, [Routes])
}

export default useOrderLink
